import * as yup from "yup";
import { checkCurpSolicitudViolencia, checkFilesSizeSolicitudViolencia } from "./formMethodsSolicitudViolencia";
import { FileValidated } from "@dropzone-ui/react";

//Schema para validar la data del formulario
export const solicitudViolenciaSchema = yup.object().shape({
  demandingName: yup.string().required('Este campo es requerido'),
  demandingFirstLastName: yup.string().required('Este campo es requerido'),
  demandingSecondLastName: yup.string().required('Este campo es requerido'),
  demandingPhone: yup.string().required("El campo es requerido").matches(/^[0-9]+$/, "Solo puedes ingresar números").min(10, 'Deben de ser mínimo 10 números').max(10, 'Deben de ser máximo 10 números'),
  demandingCurp: yup.string().required("El campo es requerido").test('len', 'Deben de ser 18 caracteres', val => val?.length === 18).test('curp', 'La CURP no es válida', val  => checkCurpSolicitudViolencia(val as string)),
  demandingEmail: yup.string().email('El correo no es válido'),
  demandingDescription: yup.string().required('Este campo es requerido').test('len', 'Has excedido el máximo de 500 caracteres', val => ((val?.length || 0) <= 500)),
  demandingFiles: yup
    .array()
    .required("Por favor, los documentos correspondientes")
    .test("len", "Por favor, sube los documentos correspondientes", val => (((val?.length || 0) > 0)))
    .test('fileSize', 'Los archivos adjuntos rebasan los 10MB', value => {
    return checkFilesSizeSolicitudViolencia(value as FileValidated[]);
  }),

  defendantName: yup.string().required('Este campo es requerido'),
  defendantAddress: yup.string().required('Este campo es requerido'),
});